import { FunctionComponent, memo } from "react";
import { useInteractionMetricConversion } from "hooks-for/metrics/use-interaction-metric-conversion";
import { IProps } from "./metric-slider-tick-labels.types";
import classNames from "classnames";
import "./metric-slider-tick-labels.scss";

/**
 * Format tick value based on interaction metric
 * @param props.metricData          Chart values as buckets for current metric
 * @param props.interactionMetric   Selected metric
 * @param props.tickValue           Current tick value
 * @param props.tickIndex
 */
const MetricSliderTickLabels: FunctionComponent<IProps> = ({
    metricData,
    interactionMetric,
    tickValue,
    tickIndex,
    isStyled = true,
}) => {
    const { formatTick, unitShorthand } = useInteractionMetricConversion(interactionMetric, {
        isAggregate: false,
        items: [tickValue ?? 0],
        getValue: (value) => value,
    });

    return (
        <>
            <div className="metric-slider-tick-labels">
                <span className={classNames({ "metric-slider-tick-labels__text": isStyled })}>
                    {formatTick(tickValue)}
                    {unitShorthand}
                    {tickIndex >= metricData.length &&
                        typeof metricData[metricData.length - 1] !== "undefined" &&
                        metricData[metricData.length - 1].rangeCut &&
                        "+"}
                </span>
            </div>
        </>
    );
};

export default memo(MetricSliderTickLabels);
